var React = require('react');

function Next (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"9.95 19.91 0 9.95 9.95 0 12 2.05 4.09 9.95 12 17.86 9.95 19.91"}));
}

Next.defaultProps = {"data-name":"Capa 1","viewBox":"0 0 12 19.91"};

module.exports = Next;

Next.default = Next;
